// extracted by mini-css-extract-plugin
module.exports = {"Tabs__nav":"styles_Tabs__nav__LdQjW","Tabs__tab":"styles_Tabs__tab__0czH0","active":"styles_active__Wh1vT","Tabs__content":"styles_Tabs__content__yvRoT"};